module.exports = __webpack_public_path__ + "img/hot-air-1.25544ded.png";